import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { defaultClassPrefix, prefix } from './utils';
const ColumnGroup = React.forwardRef((props, ref) => {
    const { header, className, children, classPrefix, headerHeight = 80, verticalAlign, width, ...rest } = props;
    const height = headerHeight / 2;
    const styles = {
        height,
        width,
    };
    const contentStyles = { ...styles, verticalAlign };
    const addPrefix = (name) => prefix(classPrefix)(name);
    return (React.createElement("div", Object.assign({ ref: ref, className: classNames(classPrefix, className) }, rest),
        React.createElement("div", { className: addPrefix('header'), style: styles },
            React.createElement("div", { className: addPrefix('header-content'), style: contentStyles }, header)),
        React.Children.map(children, (node) => {
            const nodeStyles = { height, ...node.props?.style, top: styles.height };
            return React.cloneElement(node, {
                className: addPrefix('cell'),
                style: nodeStyles,
                headerHeight: height,
                verticalAlign,
                children: React.createElement("span", { className: addPrefix('cell-content') }, node.props.children)
            });
        })));
});
ColumnGroup.displayName = 'ColumnGroup';
ColumnGroup.__PRO_TABLE_COLUMN_GROUP = true;
ColumnGroup.defaultProps = {
    headerHeight: 80,
    classPrefix: defaultClassPrefix('performance-table-column-group'),
};
ColumnGroup.propTypes = {
    header: PropTypes.node,
    classPrefix: PropTypes.string,
    verticalAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
};
export default ColumnGroup;
